module.exports = __webpack_public_path__ + "static/media/Sekk.c72b74b7.PNG";